import React from "react";
import OverviewView from "../../../../views/dashboard/reports/overview";

const Overview = () => {
  return <OverviewView />;
};

export default Overview;
